import ME from './me.gql';
import SAVE_BUSINESS from './saveBusiness.gql';

export {
  ME,
  SAVE_BUSINESS,
};
